import {combineReducers} from 'redux';

import recordsReducer from './recordsSlice';


export const UserAgreementsReducer = combineReducers({
                                                         records: recordsReducer,
                                                     });

